import HttpMethodType from 'HttpMethodType';
import SubSystemType from 'SubSystemType';
import BaseServiceRequest from 'BaseServiceRequest';

class GetCustColUnits extends BaseServiceRequest {
    constructor() {
        super();
        super.addRequestUri("getdefcustomcolinfo.pb");
    }

    getMethod() {
        return HttpMethodType.GET;
    }

    getSubSystem() {
        return SubSystemType.LIST;
    }

    getMessageName() {
        return "customCalcDefaultResponse";
    }
}

export default GetCustColUnits;

